import { Visibility, VisibilityOff } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Button,
  Dialog,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Box } from "@mui/system";
import * as React from "react";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { checkTenantApi } from "../axios/api";
import {
  allRoutePathsFunc,
  patientPortalRoutes,
} from "../constants/allRoutePaths";
import {
  collapsedDrawerWidth,
  openDrawerWidth,
} from "../constants/sideBarwidth";
import { adminSubPath, patientsSubTab } from "../constants/tabs";
import { useAuth, useAxios } from "../hooks/auth";
import useIsPrevileges from "../hooks/useRoleAndPrivileges";
import { updateSelectedPatient } from "../store/slices/selectedPatientSlice";
import {
  updateCollapsedOnNavigate,
  updateIscollapsed,
} from "../store/slices/sideBarCollapseSlice";
import {
  notificationToastError,
  notificationToastSuccess,
} from "../utils/notification";
import TenantPulldown from "./misc/pulldowns/TenantPulldown";
import classes from "./sideBar.module.css";

export default function PermanentDrawerLeft({ tabPath, email, tenantId }) {
  const { isCollapsed, isCollapsedOnNavigate } = useSelector(
    (state) => state.sideBarCollapseSelector,
  );
  const dispatch = useDispatch();
  const privelegesArray = useIsPrevileges();
  const {
    login,
    logout,
    handleLogout,
    error,
    setError,
    getScoringIntegrationPulldown,
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isPatientsTabOpen, setIsPatientsTabOpen] = React.useState(false);
  const allRoutePaths = allRoutePathsFunc(
    privelegesArray?.privileges?.subtab?.includes("signOrder") || false,
  );
  const [isMouseEventRequired, setisMouseEventRequired] = React.useState(false);
  const [formState, setFormState] = useState({ tenantId: "", password: "" });
  const [formErrorState, setFormErrorState] = useState({
    tenantId: "",
    message: "",
    password: "",
  });
  const [tenantData, setTenantData] = useState([]);
  const [passwordPopup, setPasswordPopup] = useState(false);
  const axios = useAxios();
  const passwordRef = React.useRef("");
  const [showPassword, setShowPassword] = useState(false);
  const [cookies] = useCookies();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (error) {
      notificationToastError(error);
      setError(null);
    }
  }, [error]);

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (
        showPassword &&
        passwordRef?.current &&
        !passwordRef?.current.contains(e.target)
      ) {
        setShowPassword(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [showPassword]);

  useEffect(() => {
    const checkTenant = async () => {
      try {
        const data = await checkTenantApi(axios, { email });
        const filteredTenants = data?.tenants?.filter(
          (t) => t.tenantId !== tenantId,
        );
        setTenantData(filteredTenants);
      } catch (error) {
        console.error("Error checking tenant:", error);
      }
    };

    checkTenant();
    getScoringIntegrationPulldown();
  }, [email, tenantId]);

  const updateInput = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      [e.target.id || e.target.name]: e.target.value,
    }));
    if (e.target.value) setPasswordPopup(true);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleInputField = (e) => {
    if (showPassword) {
      setShowPassword(false);
    }
    setFormState((prevState) => ({
      ...prevState,
      [e.target.id || e.target.name]: e.target.value,
    }));

    if (e.target.name === "password") {
      setFormErrorState((prevState) => ({
        ...prevState,
        password: { error: e.target.value === "" },
      }));
    }
  };

  const handleSubmit = async () => {
    let isValid = true;

    if (formState?.password === "") {
      isValid = false;
      setFormErrorState({ ...formErrorState, password: { error: true } });
    }

    if (isValid) {
      const payload = {
        email,
        password: formState?.password,
        tenantId: formState?.tenantId,
        signIn: 1,
        switchTenant: 1,
      };
      const success = await login(payload);

      if (success) {
        notificationToastSuccess("Successful login.");

        localStorage.setItem("currentTenantId", formState?.tenantId);
        localStorage.setItem(
          "tenantChange",
          JSON.stringify({
            timestamp: Date.now(),
            tenantId: formState?.tenantId,
          }),
        );

        setFormState({ ...formState, password: "" });

        sessionStorage.removeItem("patientId");
        dispatch(updateSelectedPatient(undefined));

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      setPasswordPopup(false);
    }
  };

  const handleCancel = () => {
    setPasswordPopup(false);
    setFormState((prev) => ({
      ...prev,
      tenantId: "",
    }));
  };

  const handlecollapse = () => {
    dispatch(updateIscollapsed(!isCollapsed));
  };
  const handleCollapseOnEnter = () => {
    dispatch(updateIscollapsed(false));
  };
  // React.useEffect(() => {
  //   if (tabPath) {
  //     navigate(tabPath)
  //   }
  // }, [tabPath])
  return (
    <Drawer
      sx={{
        width: isCollapsed
          ? isCollapsedOnNavigate
            ? openDrawerWidth
            : collapsedDrawerWidth
          : openDrawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isCollapsed
            ? isCollapsedOnNavigate
              ? openDrawerWidth
              : collapsedDrawerWidth
            : openDrawerWidth,
          boxSizing: "border-box",
          transition: "all 0.2s ease-out",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box className={classes.leftArroeContainer}>
        <Tooltip
          title={isCollapsed ? "Open Menu" : "Close Menu"}
          placement="bottom"
        >
          <MenuIcon onClick={handlecollapse} />
        </Tooltip>
        {!isCollapsed && !privelegesArray?.role && (
          <Box className={classes.patientPortalContainer}>
            <Typography variant="h5" sx={{ color: "primary.main" }}>
              PATIENT PORTAL
            </Typography>
          </Box>
        )}
      </Box>

      {isCollapsed ? (
        isCollapsedOnNavigate ? (
          <List>
            {!privelegesArray?.role
              ? patientPortalRoutes?.map((linkObj, index) => {
                  return (
                    <div key={linkObj.text}>
                      <ListItemLink
                        text={linkObj.text}
                        path={linkObj.path}
                        iconComponent={linkObj.iconComponent}
                        setisMouseEventRequired={setisMouseEventRequired}
                        isMouseEventRequired={isMouseEventRequired}
                        selected={
                          linkObj.path === location.pathname ||
                          (adminSubPath?.includes(linkObj.path) &&
                            adminSubPath?.includes(location.pathname)) ||
                          (patientsSubTab?.includes(linkObj.path) &&
                            patientsSubTab?.includes(location.pathname))
                        }
                        setIsPatientsTabOpen={setIsPatientsTabOpen}
                        isPatientsTabOpen={isPatientsTabOpen}
                      />
                    </div>
                  );
                })
              : allRoutePaths.map(
                  (linkObj, index) =>
                    privelegesArray?.privileges?.tab?.find((item) =>
                      item?.tabName?.includes(linkObj?.tabName),
                    ) && (
                      <div key={linkObj.text}>
                        <ListItemLink
                          text={linkObj.text}
                          path={linkObj.path}
                          iconComponent={linkObj.iconComponent}
                          setisMouseEventRequired={setisMouseEventRequired}
                          isMouseEventRequired={isMouseEventRequired}
                          selected={
                            linkObj.path === location.pathname ||
                            (adminSubPath?.includes(linkObj.path) &&
                              adminSubPath?.includes(location.pathname)) ||
                            (patientsSubTab?.includes(linkObj.path) &&
                              patientsSubTab?.includes(location.pathname))
                          }
                          setIsPatientsTabOpen={setIsPatientsTabOpen}
                          isPatientsTabOpen={isPatientsTabOpen}
                        />
                        {
                          //  ( isPatientsTabOpen && linkObj.text === "PATIENTS" ) && <PatientsSubTab/>
                        }
                      </div>
                    ),
                )}
            <Divider />
            <Box sx={{ marginTop: "10px", wordBreak: "break-all" }}>
              {" "}
              <AccountCircleIcon />
              <Typography
                sx={{ fontWeight: "600", fontSize: "14px", margin: "0px 10px" }}
              >
                {" "}
                {email}
              </Typography>
            </Box>
            <li
              style={{
                display: "flex",
                minHeight: "57px",
                alignItems: "center",
              }}
            >
              <div style={{ paddingLeft: "20px" }}>
                <LogoutIcon
                  onClick={() =>
                    !isLoggingOut
                      ? handleLogout(true, setIsLoggingOut, isLoggingOut)
                      : undefined
                  }
                  sx={{
                    opacity: isLoggingOut ? 0.5 : 1,
                    cursor: isLoggingOut ? "not-allowed" : "pointer",
                  }}
                />
              </div>
              <Typography
                variant="link"
                sx={{
                  fontWeight: "800",
                  fontSize: "16px",
                  margin: "0px 10px",
                  opacity: isLoggingOut ? 0.5 : 1,
                  cursor: isLoggingOut ? "not-allowed" : "pointer",
                }}
                onClick={() =>
                  !isLoggingOut
                    ? handleLogout(true, setIsLoggingOut, isLoggingOut)
                    : undefined
                }
              >
                Sign Out
              </Typography>
            </li>
          </List>
        ) : (
          <List>
            {!privelegesArray?.role
              ? patientPortalRoutes?.map((linkObj, index) => (
                  <div key={linkObj.text}>
                    <ListItemLink
                      path={linkObj.path}
                      iconComponent={linkObj.iconComponent}
                      setisMouseEventRequired={setisMouseEventRequired}
                      isMouseEventRequired={isMouseEventRequired}
                      selected={
                        linkObj.path === location.pathname ||
                        (adminSubPath?.includes(linkObj.path) &&
                          adminSubPath?.includes(location.pathname)) ||
                        (patientsSubTab?.includes(linkObj.path) &&
                          patientsSubTab?.includes(location.pathname))
                      }
                    />
                  </div>
                ))
              : allRoutePaths.map(
                  (linkObj, index) =>
                    privelegesArray?.privileges?.tab?.find((item) =>
                      item?.tabName?.includes(linkObj?.tabName),
                    ) && (
                      <div key={linkObj.text}>
                        <ListItemLink
                          path={linkObj.path}
                          iconComponent={linkObj.iconComponent}
                          setisMouseEventRequired={setisMouseEventRequired}
                          isMouseEventRequired={isMouseEventRequired}
                          selected={
                            linkObj.path === location.pathname ||
                            (adminSubPath?.includes(linkObj.path) &&
                              adminSubPath?.includes(location.pathname)) ||
                            (patientsSubTab?.includes(linkObj.path) &&
                              patientsSubTab?.includes(location.pathname))
                          }
                        />
                      </div>
                    ),
                )}
            <Divider />
            <li
              style={{
                display: "flex",
                minHeight: "57px",
                alignItems: "center",
              }}
            >
              <div style={{ paddingLeft: "20px" }}>
                <LogoutIcon
                  onClick={() =>
                    !isLoggingOut
                      ? handleLogout(true, setIsLoggingOut, isLoggingOut)
                      : undefined
                  }
                  sx={{
                    opacity: isLoggingOut ? 0.5 : 1,
                    cursor: isLoggingOut ? "not-allowed" : "pointer",
                  }}
                />
              </div>
            </li>
          </List>
        )
      ) : (
        <List>
          {!privelegesArray?.role
            ? patientPortalRoutes?.map((linkObj, index) => {
                return (
                  <div key={linkObj.text}>
                    <ListItemLink
                      text={linkObj.text}
                      path={linkObj.path}
                      iconComponent={linkObj.iconComponent}
                      setisMouseEventRequired={setisMouseEventRequired}
                      isMouseEventRequired={isMouseEventRequired}
                      selected={
                        linkObj.path === location.pathname ||
                        (adminSubPath?.includes(linkObj.path) &&
                          adminSubPath?.includes(location.pathname)) ||
                        (patientsSubTab?.includes(linkObj.path) &&
                          patientsSubTab?.includes(location.pathname))
                      }
                      setIsPatientsTabOpen={setIsPatientsTabOpen}
                      isPatientsTabOpen={isPatientsTabOpen}
                    />
                  </div>
                );
              })
            : allRoutePaths.map(
                (linkObj, index) =>
                  privelegesArray?.privileges?.tab?.find((item) =>
                    item?.tabName?.includes(linkObj?.tabName),
                  ) && (
                    <div key={linkObj.text}>
                      <ListItemLink
                        text={linkObj.text}
                        path={linkObj.path}
                        iconComponent={linkObj.iconComponent}
                        setisMouseEventRequired={setisMouseEventRequired}
                        isMouseEventRequired={isMouseEventRequired}
                        selected={
                          linkObj.path === location.pathname ||
                          (adminSubPath?.includes(linkObj.path) &&
                            adminSubPath?.includes(location.pathname)) ||
                          (patientsSubTab?.includes(linkObj.path) &&
                            patientsSubTab?.includes(location.pathname))
                        }
                        setIsPatientsTabOpen={setIsPatientsTabOpen}
                        isPatientsTabOpen={isPatientsTabOpen}
                      />
                      {
                        //  ( isPatientsTabOpen && linkObj.text === "PATIENTS" ) && <PatientsSubTab/>
                      }
                    </div>
                  ),
              )}
          <Divider />
          <Box sx={{ marginTop: "10px", wordBreak: "break-all" }}>
            {" "}
            <AccountCircleIcon />
            <Typography
              sx={{ fontWeight: "600", fontSize: "14px", margin: "0px 10px" }}
            >
              {" "}
              {email}
            </Typography>
          </Box>

          <li
            style={{
              display: "flex",
              minHeight: "57px",
              alignItems: "center",
            }}
          >
            <div style={{ paddingLeft: "20px" }}>
              <LogoutIcon
                onClick={() =>
                  !isLoggingOut
                    ? handleLogout(true, setIsLoggingOut, isLoggingOut)
                    : undefined
                }
                sx={{
                  opacity: isLoggingOut ? 0.5 : 1,
                  cursor: isLoggingOut ? "not-allowed" : "pointer",
                }}
              />
            </div>
            <Typography
              variant="link"
              sx={{
                fontWeight: "800",
                fontSize: "16px",
                margin: "0px 10px",
                opacity: isLoggingOut ? 0.5 : 1,
                cursor: isLoggingOut ? "not-allowed" : "pointer",
              }}
              onClick={() =>
                !isLoggingOut
                  ? handleLogout(true, setIsLoggingOut, isLoggingOut)
                  : undefined
              }
            >
              Sign Out
            </Typography>
          </li>
        </List>
      )}

      {!cookies?.isPatient && tenantData?.length ? (
        <Box sx={{ padding: "8px" }}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              float: "left",
              color: "primary.main",
            }}
          >
            Switch Tenant:
          </Typography>
          <TenantPulldown
            tenants={tenantData}
            updateInput={updateInput}
            formState={formState}
            formErrorState={formErrorState}
            attributeName="tenantId"
          />
        </Box>
      ) : (
        ""
      )}

      {/* password popup */}
      {passwordPopup && (
        <Dialog
          open={passwordPopup}
          onClose={() => {
            setPasswordPopup(false);
          }}
        >
          <Box sx={{ padding: "10px", width: "400px" }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "500", color: "#000", fontSize: "18px" }}
            >
              Please enter Password
            </Typography>
            <Divider />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: "5px auto",
              }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                id="password"
                autoComplete="current-password"
                type={showPassword ? "text" : "password"}
                variant="standard"
                value={formState?.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={handleInputField}
                inputRef={passwordRef}
                error={formErrorState?.password?.error}
                helperText={
                  formErrorState?.password?.error ? "please enter password" : ""
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                mt: 1,
              }}
            >
              <Button onClick={() => handleCancel()} variant="outlined">
                Cancel
              </Button>
              <Button onClick={handleSubmit} variant="contained">
                Switch
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}
    </Drawer>
  );
}
export const ListItemLink = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isCollapsed, isCollapsedOnNavigate } = useSelector(
    (state) => state.sideBarCollapseSelector,
  );
  const handleIconNavigate = () => {
    navigate(props.path);
    if (isCollapsed) {
      dispatch(updateCollapsedOnNavigate(false));
      props.setisMouseEventRequired(true);
    }
  };
  const handleCollapseOnEnter = () => {
    if (isCollapsed && !props?.isMouseEventRequired) {
      dispatch(updateCollapsedOnNavigate(true));
    }
  };
  const handleCollapseOnleave = () => {
    if (isCollapsed) {
      dispatch(updateCollapsedOnNavigate(false));
      props.setisMouseEventRequired(false);
    }
  };
  return (
    <ListItem
      key={props.text}
      disablePadding
      selected={props.selected}
      sx={props.sx}
    >
      <ListItemButton
        onClick={
          location.pathname === "/scheduler" && props.path === "/scheduler"
            ? () => {}
            : handleIconNavigate
        }
        onMouseEnter={handleCollapseOnEnter}
        onMouseLeave={handleCollapseOnleave}
        className={classes.listContainer}
      >
        <ListItemIcon className={classes.IconItem}>
          {props?.iconComponent}
        </ListItemIcon>
        {!isCollapsed && (
          <ListItemText>
            {location.pathname === "/scheduler" &&
            props.path === "/scheduler" ? (
              <Typography className={classes.ItemText}>{props.text}</Typography>
            ) : (
              <Link to={props.path}>{props.text}</Link>
            )}
          </ListItemText>
        )}
        {isCollapsed && isCollapsedOnNavigate && (
          <ListItemText>
            <Link to={props.path}>{props.text}</Link>
          </ListItemText>
        )}
      </ListItemButton>
    </ListItem>
  );
};
